import { Components, Theme } from '@mui/material';

const MuiCardContent: Components<Theme>['MuiCardContent'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: theme.spacing(theme.spacingSizes.lg),
    }),
  },
};

export default MuiCardContent;
